import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	Button,
	Upload,
	Checkbox,
	Image,
	Select,
	Space,
	InputNumber,
} from 'antd'
import $ from 'jquery';
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'data':{
				'category1':10,
				'category2':10,
				'category3':10,
				'category4':10,
				'category5':10,
			},
			'categoryList':[],
			//'quantity':1,
		};
	}
	
	componentDidMount()
	{
		this.getCategoryList(0)
			.then(data=>{
				let categoryList = this.parseCategoryList(data);
				this.setState({
					'categoryList':categoryList,
				});
			});
	}
	
	getCategoryList(categoryId,notLoop)
	{
		let url = pcUrl('orderCategory','index');
		let param = {
			'category_id':categoryId,
			'not_loop':notLoop?1:0,
			'order_type':this.props.orderType,
		};
		
		return new Promise((resovle,reject)=>{
			httpPost(url,param)
				.then(data=>{
					resovle(data);
				});
		});
	}

	//init({quantity,categoryIds})
	init({
		categoryIds,
	})
	{
		/*
		this.setState({
			'quantity':quantity,
		});
		*/
		
		if(categoryIds && categoryIds.length)
			this._init(categoryIds);
	}
	
	_init(categoryIds,index)
	{
		if(!index) index = 0;
		
		let categoryId = categoryIds.shift();
		let categoryList = this.state.categoryList;
		let currentRow = categoryList[index]['children'];
		currentRow.forEach(row=>row.selected = false);
		let info = currentRow.find(row=>row['category_id'] == categoryId);
		info.selected = true;
		categoryList = categoryList.filter((row,i)=>i<=index);
		
		this.getCategoryList(categoryId,1)
			.then(data=>{
				categoryList = categoryList.concat(this.parseCategoryList(data));
				this.state.categoryList = categoryList;
				this.setState({
					'categoryList':categoryList,
				});
				if(categoryIds.length)
					this._init(categoryIds,++index);
			});
	}
	
	quantityChange(type,index)
	{
		let quantity = this.state.quantity;
		
		if('-' == type)
		{
			if(quantity == 1) return false;
			quantity--;
		}
		else if('+' == type)
		{
			quantity++;
		}
		this.setState({'quantity':quantity});
	}
	
	//将分类对象转换为数组格式
	parseCategoryList(data)
	{
		if(!data.children || !data.children.length)
			return [];
		
		let result = [
			{
				'name':data['child_category_name'] || '',
				'children':data.children,
			}
		];
		if(data.children[0].children)
		{
			data.children[0].selected = true;
			result = result.concat(this.parseCategoryList(data.children[0]));
		}
		
		return result;
	}
	
	handleCategoryChange(index,index1)
	{
		let categoryList = this.state.categoryList;
		categoryList[index]['children'].forEach(row=>row.selected = false);
		let selectInfo = categoryList[index]['children'][index1];
		selectInfo.selected = true;
		
		//获取选中的子目录
		this.getCategoryList(selectInfo['category_id'])
			.then(data=>{
				categoryList = categoryList.filter((row,i)=>i <= index);
				categoryList = categoryList.concat(this.parseCategoryList(data));
				this.setState({
					'categoryList':categoryList,
				});
			});
	}
	
	getCategoryResult()
	{
		let result = {
			'flag':true,
			'message':'',
			'data':[
				[],
				[],
			],
			//'quantity':this.state.quantity,
		};
		
		let categoryList = this.state.categoryList;
		categoryList.some((row,index)=>{
			let name = row.name;
			if(!name) name = '行业类别';
			
			let checkedInfo = row.children.find(row1=>row1.selected);
			if(!checkedInfo)
			{
				result.flag = false;
				message = '请选择'+name;
				return true;
			}
			
			result.data[0].push(checkedInfo['category_id']);
			result.data[1].push({
				'name':name,
				'value':checkedInfo['category_name'],
			});
		});
		return result;
		
		/*
		let _this = this;
		$('.order-category').find('dl').each(function(){
			if(!result.flag) return;
			
			let data = {};
			data.name = $(this).find('dt').data('name');
			data.label = $(this).find('dt').text();
			let checked = $(this).find('dd a.selected');
			if(!checked.length)
			{
				result['flag'] = false;
				result['message'] = '请选择'+data.label;
			}
			data.value = checked.data('id');
			data.exp = checked.text();
			result.data.push(data);
		});
		*/
		
		return result;
	}
	
	render()
	{
		return (
			<div>
				{/*
				<Button onClick={()=>this.getCategoryList()} danger>刷新列表</Button>
				*/}
				<div className="order-category">
					{this.state.categoryList.map((row,index)=>(
						<dl>
							<dt>{row.name || '行业类别'}</dt>
							<dd>
								{row.children.map((row1,index1)=>(
									<a href="javascript:;" className={row1.selected ? 'now':''} onClick={()=>this.handleCategoryChange(index,index1)}>{row1['category_name']}</a>
								))}
							</dd>
						</dl>
					))}
					{/*
					<dl>
						<dt>数量</dt>
						<dd>
							<Input.Group>
								<Space size={2}>
									<Button onClick={()=>this.quantityChange('-')}>-</Button>
									<InputNumber value={this.state.quantity} style={{'width':'80px','textAlign':'center'}} onChange={val=>{  this.setState({'quantity':val});}} />
									<Button onClick={()=>this.quantityChange('+')}>+</Button>
								</Space>
							</Input.Group>
						</dd>
					</dl>
					*/}
				</div>
				<div className="text-center">
				</div>
			</div>
		);
	}
}
